import React, { useRef } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faSortAmountDown,
  faSortAmountUp,
} from "@fortawesome/free-solid-svg-icons";
import SearchFilter from "./SearchFilter";
import { useOnClickOutside, useModal } from "../../../hooks";
interface WrapperProps {
  analytics?: boolean;
}
const SearchFilterContainer = (props: Props) => {
  const {
    children,
    analytics,
    selectedFilters,
    filters,
    dataFilters,
    name = "Filters",
    setDataFilters,
  } = props;
  const popup = useModal();
  const ref = useRef();
  useOnClickOutside(ref, popup.close);

  function processObject(selectedFilters, filters) {
    const result = {};
    let count = 0;
    const excludedKeys = [
      "timeframe",
      "customStartDate",
      "customEndDate",
      "sortBy",
      "sortOrder",
      "jobs",
    ];
    for (const key in selectedFilters) {
      if (selectedFilters.hasOwnProperty(key)) {
        const values = selectedFilters[key];
        if (excludedKeys.includes(key)) {
          continue;
        }
        // Ignore if values is an empty array
        if (Array.isArray(values) && values.length === 0) {
          continue;
        }

        // Ignore if values length matches lengthVariable
        const lengthVariable =
          filters && filters[key] ? Object.entries(filters[key]).length : null;
        if (
          lengthVariable == null ||
          (Array.isArray(values) && values.length === lengthVariable)
        ) {
          continue;
        }
        console.log(count, "count");
        // Set the count and increment
        result[key] = count;
        count++;
      }
    }

    return count;
  }
  const filterCount = processObject(selectedFilters, filters);
  return (
    <FilterButtonWrapper ref={ref}>
      <Button analytics={analytics} type="button" onClick={popup.toggle}>
        <FilterIcon
          icon={
            name == "Sort By"
              ? dataFilters.sortOrder[0] == "asc" ||
                dataFilters.sortOrder == "asc"
                ? faSortAmountUp
                : faSortAmountDown
              : faFilter
          }
        />
        {filterCount !== 0 && <FilterCount>{filterCount}</FilterCount>}
        <span>{name}</span>
      </Button>
      {popup.isOpen && (
        <SearchFilter
          name={name}
          analytics={analytics}
          onClose={popup.close}
          filters={filters?.sortOrder}
          dataFilters={dataFilters}
          setDataFilters={setDataFilters}
        >
          {children}
        </SearchFilter>
      )}
    </FilterButtonWrapper>
  );
};

const FilterIcon = styled(FontAwesomeIcon)`
  // margin-right: 0.5rem;
`;

const FilterCount = styled.div`
  position: absolute;
  right: -5px;
  top: -10px;
  width: 20px;
  height: 20px;
  color: white;
  border-radius: 50%;
  background: #f2008c;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;
const FilterButtonWrapper = styled.div`
  position: relative;
`;

const Button = styled.button<WrapperProps>`
  height: 100%;
  border: 0;
  background: none;
  color: ${({ theme }) => theme?.colors?.primary || "#f2008c"};
  background-color: ${({ theme }) => theme?.colors?.primaryLight || "#fff1f9"};
  border: 1px solid ${({ theme }) => theme?.colors?.primary || "#f2008c"};
  padding: 0.5rem 1rem;
  font-weight: 700;
  border-radius: ${(props) => (props.analytics ? "25px" : "3px")};
  transition: background-color ease-in-out 180ms;

  :hover,
  :focus {
    background-color: ${({ theme }) =>
      theme?.colors?.primaryLightHover || "#ffe4f3"};
  }
  span {
    margin-left: 0.5rem;
    @media (max-width: 700px) {
      display: none;
    }
  }
`;

type Props = {
  children: React.ReactNode;
  analytics?: boolean;
  selectedFilters?: any;
  filters?: any;
  name?: string;
  setDataFilters?: any;
  dataFilters?: any;
};

export default SearchFilterContainer;
